import React from "react";
import ErrorMessage from "components/Popups/Messages/ErrorMessage";
import SuccessMessage from "components/Popups/Messages/SuccessMessage";

const FinicityEnablingModal = ({ message, errorMessage }) => {
  return (
    <div>
      {!errorMessage && <SuccessMessage mainMessage={message} />}
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};

export default FinicityEnablingModal;
